var exports = {
  "k": "x61f99309--1b89d5--container",
};

module.exports = exports;
